export default import.meta.ROLLDOWN_FILE_URL_jT9ctQU36D9OFz_M9$qOkQ